import tributeOptions from 'core/includes/plugins/tribute-options';
import type { PluginInjection } from 'core/types';
import { getPluginByCode } from './get-plugin';

export function populateTribute(pluginsCodes: string[], docAttrs: any = {}) {
  const pluginsList: PluginInjection[] = [];

  let i = 0;
  pluginsCodes.forEach(code => {
    const plugin = getPluginByCode(code, docAttrs);

    if (plugin) {
      pluginsList.push({
        key: i,
        ...plugin,
      });

      i++;
    }
  });

  tributeOptions.values = pluginsList;

  return tributeOptions;
}
